import configureStore from "./configureStore";

const store = configureStore();

export default store;



// WEBPACK FOOTER //
// ./src/app/store/index.js